// GENERATED FILE - DO NOT MODIFY

export enum GetOperatorsSortColumnDto {
    CompanyName = "CompanyName",
    Name = "Name",
    Email = "Email",
    VenuesCount = "VenuesCount",
    ManagementRoles = "ManagementRoles",
}